var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import { Para } from "@irati/ui/src/Labels";
import { greys } from "@irati/ui/src/global/colors";
import padding from "@irati/ui/src/global/padding";
import authentication from "@irati/auth";
import ErrorText from "@irati/ui/src/ErrorText";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var WrapperDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var TotalDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 20px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 20px;\n"])));
var Card = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: 3px;\n  border: 1px solid ", ";\n  margin-bottom: ", ";\n  padding: ", ";\n"], ["\n  border-radius: 3px;\n  border: 1px solid ", ";\n  margin-bottom: ", ";\n  padding: ", ";\n"])), greys.medium, padding.tiny, padding.tiny);
var StyledPara = styled(Para)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var LeftPara = styled(Para)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  float: left;\n"], ["\n  float: left;\n"])));
var Totals = /** @class */ (function (_super) {
    __extends(Totals, _super);
    function Totals() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderErrorText = function () {
            return (React.createElement(ErrorText, null,
                React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.error" })));
        };
        _this.getUpdatedRewardBalance = function () {
            var updatedRewardWalletBalance = _this.props.updatedRewardWalletBalance;
            if (updatedRewardWalletBalance.amount < 0) {
                return _this.renderErrorText();
            }
            return formatCurrency({
                currencyCode: updatedRewardWalletBalance.currency,
                value: updatedRewardWalletBalance.amount, isCents: false
            });
        };
        _this.getUpdatedTenentBalance = function () {
            var _a = _this.props, updatedRewardWalletBalance = _a.updatedRewardWalletBalance, updatedBalance = _a.updatedBalance;
            if (updatedRewardWalletBalance.amount < 0) {
                return _this.renderErrorText();
            }
            return formatCurrency({
                currencyCode: updatedBalance.currency,
                value: updatedBalance.amount, isCents: false
            });
        };
        return _this;
    }
    Totals.prototype.render = function () {
        var _a = this.props, amount = _a.amount, currency = _a.currency, recipients = _a.recipients, updatedBalance = _a.updatedBalance, wallet = _a.wallet;
        if (recipients.length === 0) {
            return null;
        }
        if (updatedBalance.amount < 0) {
            return (React.createElement(Card, null,
                React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.insufficient" })));
        }
        var tenantName = authentication.userTenant().public_name;
        return (React.createElement(React.Fragment, null,
            React.createElement(Card, null,
                React.createElement(StyledDiv, null,
                    React.createElement(WrapperDiv, null,
                        React.createElement(LeftPara, null,
                            React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.rewardWallet", values: { fullName: firstnameLastname(recipients[0]) } })),
                        React.createElement(StyledPara, null,
                            React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.available", values: {
                                    total: formatCurrency({ currencyCode: wallet.currency, value: wallet.availableBalance, isCents: false })
                                } })),
                        React.createElement(StyledPara, { bold: true },
                            React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.minus", values: {
                                    total: formatCurrency({ currencyCode: currency, value: amount, isCents: false })
                                } })),
                        React.createElement(StyledPara, { flush: true },
                            React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.updated", values: { total: this.getUpdatedRewardBalance() } }))))),
            React.createElement(WrapperDiv, null,
                React.createElement(TotalDiv, null,
                    React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.wallet", values: { tenantName: tenantName } }),
                    React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.updated", values: { total: this.getUpdatedTenentBalance() } })))));
    };
    return Totals;
}(Component));
export default Totals;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
